import {useCallback, useMemo} from "react";
import ApiServiceV2 from "../services/ApiServiceV2";
import {routes} from "./routes";
import {StoredIndividualization} from "../types/Individualization";

export const useToggleVisibility = (url: keyof typeof routes) => {
    const api = useMemo(() => {
        return new ApiServiceV2()
    }, [])

    //api call
    const handleToggle = useCallback( (element: StoredIndividualization) => {
        return api.callApi(routes[url] + '/' + element.id, 'post', {active: !element.active})
    }, [url, api])

    return {
        toggle: handleToggle
    }
}
